import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './common.intl.json';

/**
 * Please only use these translations for components under the
 * components/common folder.
 */
export const useCommonIntl = () => useIntlModule(messages);
